import { render, staticRenderFns } from "./IdentifierList.vue?vue&type=template&id=ad01716e&scoped=true"
import script from "./IdentifierList.vue?vue&type=script&lang=js"
export * from "./IdentifierList.vue?vue&type=script&lang=js"
import style0 from "./IdentifierList.vue?vue&type=style&index=0&id=ad01716e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad01716e",
  null
  
)

export default component.exports